import { useCallback, useContext, useEffect, useState } from 'react';
import { storesContext } from '../../../stores/storesContext';

const useUserBlocks = () => {
  const userStore = useContext(storesContext);
  const blockScanningStore = userStore.blockScanningStore;
  const [blocksOffset, setBlocksOffset] = useState(
    blockScanningStore.userBlocks.length
  );
  const [hasMoreBlocks, setHasMoreBlocks] = useState(true);
  const blocksPageSize = 100;

  const fetchUserBlocks = useCallback(async () => {
    if (!userStore.selectedDatabase) return;
    const response = await blockScanningStore.fetchUserBlocks(
      blocksPageSize,
      blocksOffset
    );
    if (response.data.length < blocksPageSize) {
      setHasMoreBlocks(false);
      return;
    }
    setBlocksOffset(response.page.next_offset);
  }, [blockScanningStore, blocksOffset, userStore.selectedDatabase]);

  useEffect(() => {
    const fetchData = async () => {
      if (hasMoreBlocks) fetchUserBlocks();
    };
    fetchData();
  }, [fetchUserBlocks, hasMoreBlocks]);

  return blockScanningStore.userBlocks;
};

export default useUserBlocks;

